<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <footer class="the-footer " :class="classes">
    <div class="footer flex" :class="{ 'reduced': verticalNavMenuItemsMin }" @click="displayHelp()">
      <div class="logo-cma-pwd"></div>
    </div>
    <div class="pwd-cma footer flex" @click="displayHelp()" v-if="!verticalNavMenuItemsMin">
      <div>Powered by CMA</div>
      <div>COPYRIGHT @ {{ new Date().getFullYear() }} </div>
    </div>
    <div class="footer flex attendance-icon" @click="displayAttendance()" v-if="!verticalNavMenuItemsMin">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 448 448" xml:space="preserve">
        <g>
          <g>
            <g>
              <path
                d="M384,172.4C384,83.6,312.4,12,224,12S64,83.6,64,172c0,0,0,0,0,0.4C28.4,174.4,0,204,0,240v8c0,37.6,30.4,68,68,68h3.6
				        l28.4,45.2c20,32,54,50.8,91.6,50.8h5.6c3.6,13.6,16,24,30.8,24c17.6,0,32-14.4,32-32c0-17.6-14.4-32-32-32
				        c-14.8,0-27.2,10.4-30.8,24h-5.6c-32,0-61.2-16.4-78-43.6L90.4,316H96c8.8,0,16-7.2,16-16V188c0-8.8-7.2-16-16-16H80
				        c0-79.6,64.4-144,144-144s144,64.4,144,144h-16c-8.8,0-16,7.2-16,16v112c0,8.8,7.2,16,16,16h28c37.6,0,68-30.4,68-68v-8
				        C448,204,419.6,174.4,384,172.4z M228,388c8.8,0,16,7.2,16,16s-7.2,16-16,16s-16-7.2-16-16S219.2,388,228,388z M96,188v112H68
				        c-28.8,0-52-23.2-52-52v-8c0-28.8,23.2-52,52-52H96z M432,248c0,28.8-23.2,52-52,52h-28V188h28c28.8,0,52,23.2,52,52V248z" />

              <path 
                d="M290.4,72.4c-0.8-0.4-2-1.2-3.2-2c-1.2-0.8-2.4-1.6-3.2-2c-3.6-2.4-8.8-1.2-10.8,2.8S272,79.6,276,82
				        c0.8,0.4,2,1.2,3.2,2s2.4,1.6,3.6,2c1.2,0.8,2.8,1.2,4,1.2c2.8,0,5.2-1.2,6.8-4C295.6,79.6,294.4,74.8,290.4,72.4z" />

              <path 
                d="M224,52c-34,0-66,14.8-88,40.4c-2.8,3.2-2.4,8.4,0.8,11.2c1.6,1.2,3.2,2,5.2,2c2.4,0,4.4-0.8,6-2.8
				        c19.2-22,46.8-34.8,76-34.8c7.2,0,14.4,0.8,21.6,2.4c4.4,0.8,8.4-2,9.6-6s-2-8.4-6-9.6C240.8,52.8,232.4,52,224,52z" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    },
    verticalNavMenuItemsMin: { type: Boolean }
  },
  data() {
    return {};
  },
  methods: {
    displayHelp() {
      this.$emit("displayPopupHelp", true);
    },
    displayAttendance() {
      this.$emit("displayPopupAttendance");
    }
  }
};
</script>

<style lang="scss">
.theme-dark a {
  // color: #FFF;
}

.the-footer {
  // padding: 0;
  font-size: 9px;
  justify-content: center;
  display: flex;

  // text-align: center;
  .footer {

    .pwrby,
    .copy-footer {
      font-size: 1.2em;
    }

    .logo-cma-pwd {
      width: 60px;
      height: 23px;
      // margin-left: 17px;
      // margin-right: 10px;
      // margin-bottom: 13px;
    }
  }
}

.footer-power {
  color: #888;
  text-align: right;
}

.btn-help {
  color: #999 !important;
  height: 35px;
  line-height: 5px;
  margin-top: 5px;
  width: 80px;
}

.btn-help:hover {
  background-color: #ccc !important;
}

.theme-dark .btn-help:hover {
  background-color: #949592 !important;
}

.footer-block {
  width: 100%;
}

.footer-content {
  display: flex;
  justify-content: center;
}

.footer-content-logo-cma {
  /* border-right: 1px solid rgba(0, 0, 0, 0.1); */
  padding-right: 20px;
  /* margin-right: 20px; */
}

.help-btn {
  align-self: center;
}

span.desc-help {
  position: absolute;
  line-height: 20px;
  margin-left: 5px;
}

.footer-content-logo-cma-min {
  margin-bottom: 35px;

  .logo-cma-pwd {
    /* width: 65px;
    background-repeat: no-repeat;
    margin-left: -10px; */
  }
}
</style>
